import * as React from 'react';
import './index.scss';
import { fetch, RankItem, GetRichRankRsp } from '@/fetch.ts';
import AnchorItem from '@hooks/web/public/anchorItem.tsx';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
import RankHeader from '@hooks/web/public/rankHeader.tsx';
const { useEffect, useState } = React;
const RichRank: React.FC = () => {
  const [list, List] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const [pageShow, PageShow] = useState<boolean>(true);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 5, (index + 1) * 5 >= list.length ? list.length : (index + 1) * 5));
  }
  useEffect(() => {
    PageShow(false);
    fetch.getRichRank(
      {},
    )
      .then((rsp: GetRichRankRsp) => {
        // console.log('神豪榜', JSON.stringify(rsp));
        PageShow(true);
        List(rsp.vRank.value.slice(0, 25));
        ShowList(rsp.vRank.value.slice(0, 5));
      })
  }, [])
  return (
    <div
      className='web-richRank'
    >
      <RankHeader
        width={855}
        color='#ffefbf'
        prev='排名'
        mid='神豪昵称'
        next={'贡献值'}
      />
      <div className='rich-List'>
        {
          showList.length === 0 ?
            <None text={'暂无神豪榜数据'} />
            :
            showList.map((item: RankItem) => (
              <AnchorItem
                key={item.tJump.lPid}
                width={860}
                {...item}
                rich={true}
              />
            ))
        }
      </div>
      {
        pageShow &&
        <div className='web-pageCover'>
          <Page
            pageLen={list.length % 5 === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1}
            setPageIndex={pageChange}
          />
        </div>
      }
    </div>
  )
}

export default RichRank;